export const COMPANY_TABLE_COLUMN_ORDER_USER_PREFERENCES_KEY = 'companyTableColumnOrder';
export const CUSTOMER_TABLE_COLUMN_ORDER_USER_PREFERENCES_KEY = 'customerTableColumnOrder';